module.exports = __webpack_public_path__ + "static/discount1-e5cf8b8f4ce32c73785c45e88097a973.jpg";